@if (
  {
    expanded: (expanded$ | async)!,
    items: (items$ | async)!
  };
  as context
) {
  <now-wbsuche-lib-basis-facette
    [id]="'unterrichtszeit'"
    [label]="'Unterrichtszeit'"
    [facettenService]="facettenService"
    [isLoading]="(this.loaderService.facettenLoadingFirstTime$ | async)!"
  >
    @if (context.expanded) {
      <now-wbsuche-lib-checkbox-facette
        [label]="'Unterrichtszeit'"
        [komponentenId]="'unterrichtszeitFacette'"
        [selectItems]="context.items"
        (selected)="updateSelectedIds($event)"
        [facetteLoading]="(loaderService.facettenLoading$ | async)!"
      ></now-wbsuche-lib-checkbox-facette>
    }
  </now-wbsuche-lib-basis-facette>
}
